(function () {
    function mainCode($) {
        $(document).off("Searchanise.ResultsUpdated");
        $(document).on("Searchanise.ResultsUpdated", function () {
            if (window.innerWidth <= 768) {
              
//                 $('.snize-selected-filters-container .snize-main-panel').css('display','none');
          
//              $('.snize-selected-filters-container').insertAfter('.snize-main-panel');
//              $('.snize-selected-filters').css('display','none');
               return;
            }

            var selectedFilters = [];

            $('.snize-product-filters-list input:checked').each(function () {
                selectedFilters.push([
                    $(this).parents('.snize-filter-checkbox').next('span').contents().get(0).nodeValue,
                    $(this).val()
                ]);
            });

            $('.snize-product-color-filters-checkbox:checked').each(function () {
                selectedFilters.push([
                    $(this).val(),
                    $(this).val()
                ]);
            });

            if (selectedFilters.length) {
             		console.log(selectedFilters.length);
                $('.snize-selected-filters').remove();
                $("div.snize-header").after('<div class="snize-selected-filters"><ul></ul></div>');

                $(".snize-selected-filters ul").append('<li class="snize-filter-button snize-clear-all-button"><div class="snize-clear-icon"><svg viewBox="0 0 11.893 11.894" width="12" height="12"><path d="M6.5 5.95l5.4-5.4-.56-.55-5.4 5.4L.57 0 0 .56l5.4 5.4L0 11.33l.56.56 5.4-5.4 5.38 5.4.55-.56" fill="#1a489b"></path></svg></div><span>Clear all</span></li>');

                for (var i = 0; i < selectedFilters.length; i++) {
                    var filter_name = selectedFilters[i][0];
                    var filter_value = selectedFilters[i][1];

                    $(".snize-selected-filters ul").append('<li class="snize-filter-button" data-value="' + filter_value + '"><span class="snize-clear-the-filter">' + filter_name + '</span><div class="snize-clear-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="product-listing-filtered" transform="translate(-640.000000, -266.000000)" fill="#1A489B"><g id="Group-3" transform="translate(640.000000, 266.000000)"><rect id="Rectangle" transform="translate(4.949747, 4.949747) rotate(45.000000) translate(-4.949747, -4.949747) " x="-1.05025253" y="3.94974747" width="12" height="2" rx="1"></rect><rect id="Rectangle" transform="translate(4.949747, 4.949747) scale(-1, 1) rotate(45.000000) translate(-4.949747, -4.949747) " x="-1.05025253" y="3.94974747" width="12" height="2" rx="1"></rect></g></g></g></svg></div></li>');
                }
//               setTimeout(function(){
//                  $('.snize-main-panel-collection-results-found').appendTo('.snize-selected-filters');
//               },100);
              
              
            } else {
              
                $('.snize-selected-filters').remove();
            }
        });

        $(document).off("click", ".snize-filter-button");
        $(document).on("click", ".snize-filter-button", function (e) {
            $('.snize-selected-filters').remove();
            $('[value="' + $(this).data('value') + '"]').click();
        });

        $(document).off("click", ".snize-clear-all-button");
        $(document).on("click", ".snize-clear-all-button", function (e) {
            $('.snize-selected-filters').remove();

            Searchanise.GetWidgets().searchResults.search({page: 1, restrictBy: {}});
            var timerId = setInterval(function () {
                Searchanise.GetWidgets().searchResults.search({page: 1, restrictBy: {}});
            }, 800);

            setTimeout(function () {
                clearInterval(timerId);
            }, 1500);
        });
      
//       console.log($(window).innerWidth());
//         if($(window).width() < 784)
//            {
//              console.log(0000);
//               $('.snize-selected-filters-container .snize-main-panel').css('display','none');
//              $('.snize-selected-filters-container').insertAfter('.snize-main-panel');
//              $('.snize-selected-filters').css('display','none');
//            }

    }

    function waitUntilDefined() {
        if (typeof Searchanise !== "undefined" && typeof Searchanise.$ !== "undefined") {
            mainCode(Searchanise.$);
        } else {
            setTimeout(waitUntilDefined, 400);
        }
    }

    waitUntilDefined();
})();
